import { render, staticRenderFns } from "./RichTextEditorExamples.vue?vue&type=template&id=bb815344&"
import script from "./RichTextEditorExamples.vue?vue&type=script&lang=js&"
export * from "./RichTextEditorExamples.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports